import { includes, filter as ramdaFilter } from 'ramda';

const filterAvailableProperties = (cmsProperties, extranetProperties) => {
  const extranetPropertyIds = extranetProperties.map(({ id }) => id);
  const availableProperties = ramdaFilter(
    ({ id }) => includes(id, extranetPropertyIds),
    cmsProperties,
  );

  return availableProperties;
};

export default filterAvailableProperties;
